import { useQuery } from '@tanstack/react-query';
import { reportQueryKeys } from '../all-query-keys';
import { getProjectReport } from '../../../admin/Services/ProjectReportService';

const mapRows = (content = []) =>
  content.map((row, index) => ({
    id: `${row.employeeId || 'emp'}-${row.projectId || 'proj'}-${index}`,
    employeeName: row.employeeName || '',
    employeeCode: row.employeeCode ?? '',
    projectName: row.projectName || '',
    isManager: row.isManager ? 'Yes' : 'No',
    numberOfManagers: row.numberOfManagers ?? 0,
    managerNames: row.managerNames || '',
  }));

export const useGetProjectReport = ({
  filters,
  pageNumber,
  pageSize,
  sortBy,
  sortDirection,
  enabled = true,
}) => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: reportQueryKeys.projectReport(
      filters,
      pageNumber,
      pageSize,
      sortBy,
      sortDirection
    ),
    queryFn: () =>
      getProjectReport({
        ...filters,
        pageNumber,
        pageSize,
        sortBy,
        sortDirection,
      }),
    enabled,
    keepPreviousData: true, // Keep old data on screen while fetching next page
  });

  const responseData = data?.data?.data || data?.data;
  const rows = mapRows(responseData?.content || []);
  const totalPage = responseData?.totalPages || 0;

  return {
    rows,
    totalPage,
    isLoading,
    isError,
    error,
    refetch,
  };
};
